import axios from "axios";


export default axios.create({
    baseURL: process.env.REACT_APP_API_DISPOSISI,
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
    },
});
